import { useEffect } from 'react';

import { useLocation } from 'react-router-dom';

import { OrganizationType } from '@cast/types';

import {
  buildEnterpriseUrl,
  useNavigate,
  useViewedOrganization,
} from '@cast/infrastructure-organization';

import { BASE_PATHS } from '@oneclick/constants/navigation';

const isEnterpriseSettingsPath = (pathname: string) =>
  pathname.includes('/organization/enterprise/');

export const useEnterpriseOrganizationRouteGuard = () => {
  const viewedOrganization = useViewedOrganization();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (viewedOrganization?.type !== OrganizationType.ENTERPRISE) {
      return;
    }

    if (isEnterpriseSettingsPath(location.pathname)) {
      return;
    }

    if (
      location.pathname.startsWith(BASE_PATHS.forbidden) ||
      location.pathname.startsWith(BASE_PATHS.onboarding) ||
      location.pathname.startsWith(BASE_PATHS.apiAccess)
    ) {
      return;
    }

    navigate(buildEnterpriseUrl(viewedOrganization.id, 'overview'), {
      replace: true,
    });
  }, [viewedOrganization, location.pathname, navigate]);
};
